import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { ScreeningKanBanStatusEnum } from '@/app/common/general-types/social-screening.dto';
import { ScreeningResultsService } from '../../services/screening-results/screening-results.service';

/** Kanban status → the word shown in the band's leading pill. */
const STATUS_LABEL: Record<string, string> = {
  [ScreeningKanBanStatusEnum.Not_Ready]: 'Not ready',
  [ScreeningKanBanStatusEnum.Processing]: 'Processing',
  [ScreeningKanBanStatusEnum.Refinement]: 'Needs review',
  [ScreeningKanBanStatusEnum.Screening]: 'Active',
  [ScreeningKanBanStatusEnum.Complete]: 'Complete',
};

/**
 * The page's header band: what this brief is, and the two things you can do to it.
 *
 * The status pill reflects the real kanban value. Note the API never sets `Complete` today (the
 * `screening_completed` webhook is a no-op), so "Active" is the terminal state you will see.
 */
@Component({
  selector: 'scr-screen-band',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './screen-band.html',
})
export class ScreenBand {

  readonly results = inject(ScreeningResultsService);

  /** Asks the shell to switch to the Creators tab and open the add-creator picker. */
  readonly addCreators = output<void>();

  readonly briefName = computed(() => this.results.brief()?.briefTitle?.trim() || 'Untitled brief');

  readonly statusLabel = computed(() => {
    const status = this.results.kanban()?.status;
    return status ? STATUS_LABEL[status] ?? status : undefined;
  });

  readonly isLive = computed(() => this.results.kanban()?.status === ScreeningKanBanStatusEnum.Screening);

  onAddCreators(): void {
    this.addCreators.emit();
  }
}
